import React from "react";
import ReactDOM from "react-dom";

import App from "./app";
console.log("teste");

ReactDOM.render(<App />, document.getElementById("root"));
